var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Info",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(2.500000, 2.500000)",
    stroke: "#000000",
    strokeWidth: 1.33333333
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.66666667,
    cy: 6.66666667,
    r: 6.66666667
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.66666667,
    y1: 9.33333333,
    x2: 6.66666667,
    y2: 6.66666667,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.66666667,
    y1: 4,
    x2: 6.67333333,
    y2: 4,
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.63c047e9f785b78b57fa1a9e1bb0a953.svg";
export { ForwardRef as ReactComponent };